import { render, staticRenderFns } from "./ChnlAssetMgmt.vue?vue&type=template&id=3478a26e"
import script from "./ChnlAssetMgmt.vue?vue&type=script&lang=js"
export * from "./ChnlAssetMgmt.vue?vue&type=script&lang=js"
import style0 from "./ChnlAssetMgmt.vue?vue&type=style&index=0&id=3478a26e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports